import { gql, TypedDocumentNode } from '@apollo/client';
import { WalletTypeEnum } from '@libs/backend-common';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import { HistoryPeriodEnumKeys, WalletInfoItem } from '@libs/types';
type ChangeDetails = {
  changeDetails?: {
    changeAmount: string;
    changePercentage: string;
  };
};
export type WalletInfoNew = WalletInfoItem & ChangeDetails;
export type GetWalletInfoNewResponse = {
  getWalletInfoNew: DefaultApiResponse<WalletInfoNew[]>;
};

export type GetWalletInfoNewArgs = {
  isCrypto?: boolean;
  walletType?: WalletTypeEnum;
  valueAssetCode?: string;
};
type WalletAdditionalArgs = {
  changeDetailsRecord2?: {
    period: HistoryPeriodEnumKeys;
    valueAssetCode: string;
  };
};
export const getWalletInfoDetailedNew: TypedDocumentNode<
  GetWalletInfoNewResponse,
  DefaultArg<GetWalletInfoNewArgs> & WalletAdditionalArgs
> = gql`
  query GetWalletInfoNew(
    $record: GetWalletNewRecord!
    $changeDetailsRecord2: AssetsRateRecord!
  ) {
    getWalletInfoNew(record: $record) {
      amount
      code
      changeDetails(record: $changeDetailsRecord2) {
        changeAmount
        changePercentage
      }
      color
      hasNetworks
      iconUrl
      isCrypto
      isDisabled
      isFavorite
      isStable
      name
      networksCount
      orderingPriority
      percentage
      price
      roundingPrecision
      totalValue
      value
    }
  }
`;
